export enum SocialPlatformEnum {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Waze = 'waze',
  Whatsapp = 'whatsapp',
  Phone = 'phone',
}

export type socialPlatform = SocialPlatformEnum;

export default SocialPlatformEnum;
